module.exports = __webpack_public_path__ + "static/img/preview.0b4a20de.png";